export class SoundfontFileBoxAdapter {
    #context;
    #box;
    constructor(context, box) {
        this.#context = context;
        this.#box = box;
    }
    get box() { return this.#box; }
    get uuid() { return this.#box.address.uuid; }
    get address() { return this.#box.address; }
    get soundfont() { return this.getOrCreateLoader().soundfont; }
    getOrCreateLoader() {
        return this.#context.soundfontManager.getOrCreate(this.#box.address.uuid);
    }
    terminate() { }
}
